import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 导入Element UI插件（已包含样式）
import './plugins/element.js'
//导入全局样式（应在第三方样式后导入以确保优先级）
import './assets/css/global.css'
//导入字体图标
import './assets/fonts/iconfont.css'
import axios from 'axios'
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 扩展 dayjs 以使用 isoWeek 插件
dayjs.extend(isoWeek);

// 注册富文本编辑器
Vue.use(VueQuillEditor)

// 设置Dialog组件默认配置
Vue.prototype.$ELEMENT = {
  size: 'mini',
  zIndex: 3000,
  closeOnClickModal: false
};
//配置axios的请求路径
Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://119.45.168.44:8089/sharedBicycles/'
// axios.defaults.baseURL = 'http://localhost:8989/youxin/'
axios.defaults.baseURL = 'https://www.ahzlyouxin.cn/youxin/'
axios.interceptors.request.use((config) => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  //在最后必须return config 
  return config
})
Vue.config.productionTip = false
import * as echarts from 'echarts/core'
import { BarChart, LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  CanvasRenderer
])

Vue.prototype.$echarts = echarts

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')

export default {
  echarts
}